export interface IState {
	backgroundColor: string,
	accentColor: string,
	textColor: string,
	blockColor: string,
	type: string,
	isVisitSite: boolean,
	event: {},
	pageUrl: string,
	eventId: string
}

const deafultState: IState = {
	backgroundColor: '',
	accentColor: '',
	textColor: '',
	blockColor: '',
	isVisitSite: false,
	type: '',
	event: {},
	pageUrl: '',
	eventId: ''
}

export default deafultState;
